export const progressCelebrationTranslations = {
  en: {
    pages_one: '{{count}} page added',
    pages_other: '{{count}} pages added',
    targetSummary: '{{today}} of {{dailyTarget}} today · {{week}} of {{weekTarget}} this week',
    totalSummary: '{{today}} today · {{week}} this week',
    milestoneSummary: '{{pages}} · {{today}} today · {{week}} this week',
    day: 'Today’s pace reached',
    week: 'Week complete',
    weekAndDay: 'Week complete · pace reached',
    recorded: 'A little further in your story.',
    dayBody: 'You found your reading moment today.',
    weekBody: 'Your week’s pages are in. Enjoy the next chapter at your pace.',
    today: 'Today',
    thisWeek: 'This week',
    value: '{{current}} / {{target}} pages',
    total_one: '{{count}} page',
    total_other: '{{count}} pages',
    openDay: 'See this day in your reading calendar',
    dismiss: 'Dismiss reading progress',
    yearEyebrow: 'YOUR READING YEAR',
    yearTitle: 'You read {{count}} books.',
    yearBody: 'Every chapter brought you here. Your {{year}} reading goal is complete.',
    yearProgress: '{{current}} of {{target}} books this year',
    seeYear: 'See your reading year',
    continue: 'Continue',
    skip: 'Skip for now',
    ratingTitle: 'How was {{title}}?',
    nextTitle: 'What will you read next?',
    savedForLater: 'You can add your rating and thoughts from the book’s details any time.',
    close: 'Close completion celebration',
  },
  sk: {
    pages_one: 'Pridaná {{count}} strana',
    pages_few: 'Pridané {{count}} strany',
    pages_other: 'Pridaných {{count}} strán',
    targetSummary: '{{today}} z {{dailyTarget}} dnes · {{week}} z {{weekTarget}} tento týždeň',
    totalSummary: '{{today}} dnes · {{week}} tento týždeň',
    milestoneSummary: '{{pages}} · {{today}} dnes · {{week}} tento týždeň',
    day: 'Dnešné tempo dosiahnuté',
    week: 'Týždeň splnený',
    weekAndDay: 'Týždeň splnený · tempo dosiahnuté',
    recorded: 'O kúsok ďalej v tvojom príbehu.',
    dayBody: 'Dnes si si našiel čas na čítanie.',
    weekBody: 'Týždenné stránky máš prečítané. Ďalšiu kapitolu si uži vlastným tempom.',
    today: 'Dnes',
    thisWeek: 'Tento týždeň',
    value: '{{current}} / {{target}} strán',
    total_one: '{{count}} strana',
    total_few: '{{count}} strany',
    total_other: '{{count}} strán',
    openDay: 'Pozrieť deň v čitateľskom kalendári',
    dismiss: 'Zavrieť priebeh čítania',
    yearEyebrow: 'TVOJ ČITATEĽSKÝ ROK',
    yearTitle: 'Prečítaných kníh: {{count}}.',
    yearBody:
      'Každá kapitola ťa priviedla až sem. Tvoj čitateľský cieľ na rok {{year}} je splnený.',
    yearProgress: '{{current}} z {{target}} kníh tento rok',
    seeYear: 'Pozrieť čitateľský rok',
    continue: 'Pokračovať',
    skip: 'Teraz preskočiť',
    ratingTitle: 'Aká bola kniha {{title}}?',
    nextTitle: 'Čo budeš čítať ďalej?',
    savedForLater: 'Hodnotenie a dojmy môžeš kedykoľvek pridať v detaile knihy.',
    close: 'Zavrieť oslavu dočítania',
  },
  cs: {
    pages_one: 'Přidána {{count}} strana',
    pages_few: 'Přidány {{count}} strany',
    pages_other: 'Přidáno {{count}} stran',
    targetSummary: '{{today}} z {{dailyTarget}} dnes · {{week}} z {{weekTarget}} tento týden',
    totalSummary: '{{today}} dnes · {{week}} tento týden',
    milestoneSummary: '{{pages}} · {{today}} dnes · {{week}} tento týden',
    day: 'Dnešní tempo dosaženo',
    week: 'Týden splněn',
    weekAndDay: 'Týden splněn · tempo dosaženo',
    recorded: 'O kousek dál v tvém příběhu.',
    dayBody: 'Dnes sis našel čas na čtení.',
    weekBody: 'Týdenní stránky máš přečtené. Další kapitolu si užij vlastním tempem.',
    today: 'Dnes',
    thisWeek: 'Tento týden',
    value: '{{current}} / {{target}} stran',
    total_one: '{{count}} strana',
    total_few: '{{count}} strany',
    total_other: '{{count}} stran',
    openDay: 'Zobrazit den ve čtenářském kalendáři',
    dismiss: 'Zavřít průběh čtení',
    yearEyebrow: 'TVŮJ ČTENÁŘSKÝ ROK',
    yearTitle: 'Přečtených knih: {{count}}.',
    yearBody: 'Každá kapitola tě přivedla až sem. Tvůj čtenářský cíl na rok {{year}} je splněný.',
    yearProgress: '{{current}} z {{target}} knih letos',
    seeYear: 'Zobrazit čtenářský rok',
    continue: 'Pokračovat',
    skip: 'Teď přeskočit',
    ratingTitle: 'Jaká byla kniha {{title}}?',
    nextTitle: 'Co budeš číst dál?',
    savedForLater: 'Hodnocení a dojmy můžeš kdykoli přidat v detailu knihy.',
    close: 'Zavřít oslavu dočtení',
  },
} as const;
